import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import CustomerConstants from 'pages/admin/customer/constants';
import {
    ICustomer,
    ICustomerState,
    IListCustomersSearchForm,
} from 'types/customer';

const initialState: ICustomerState = {
    customers: [],
    customer: null,
    customersSearchForm: {
        searchKeyWord: '',
        status: [CustomerConstants.status.ALL],
        source: [CustomerConstants.source.ALL],
        startDate: '',
        endDate: '',
    },
};

const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
        setCustomers: (state, action: PayloadAction<ICustomer[]>) => {
            state.customers = action.payload;
        },
        setCustomerSearchForm: (
            state,
            action: PayloadAction<IListCustomersSearchForm>
        ) => {
            state.customersSearchForm = {
                ...state.customersSearchForm,
                ...action.payload,
            };
        },
        clearCustomerSearchForm: (state) => {
            state.customersSearchForm = initialState.customersSearchForm;
        },
    },
});

export const { setCustomers, clearCustomerSearchForm, setCustomerSearchForm } =
    customerSlice.actions;

export default customerSlice.reducer;
